import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable, NgZone } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Model } from '../_models/hydra';
import { DebugService } from './debug.service';

import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';
import ReconnectingEventSource from 'reconnecting-eventsource';

@Injectable({
    providedIn: 'root'
})
export class SseService {
    private eventsSubject: BehaviorSubject<Model>;
    public events: Observable<Model>;
    private lastEventID;
    private lastEventDate:Date;
    private eventSource;
    private timeout;
    private timeoutReset;
    private reconnectFrequencySeconds = 0.1;
    private bifrostInterval;

    /**
     * Constructor
     */
    constructor(
        private zone: NgZone, 
        private http: HttpClient,
        private debugService: DebugService
    ) {
        this.eventsSubject = new BehaviorSubject<any>(null);
        this.events = this.eventsSubject.asObservable();
    }
    
    initBifrost() {
        this.debugService.send("Init Bifrost");

        if (this.bifrostInterval) {
            clearInterval(this.bifrostInterval);
        }

        this.lastEventDate = new Date();
        this.bifrostInterval = setInterval((_) => {
            // environment.debug && console.log("SSE Bifrost check. Last event : ", this.lastEventDate);
            this.debugService.send("SSE Bifrost check. Last event : " + this.lastEventDate);
            if (this.lastEventDate && this.lastEventDate.getTime() + 1000 * 15 < new Date().getTime()) {
                this.debugService.send("/!\\/!\\/!\\ SSE Bifrost KO /!\\/!\\/!\\");
                this.setupSSE();
            }
        }, 10000);
    }

    init() {
        
        this.initBifrost();

        this.close();

        this.debugService.send("SSE Bifrost discover at : " + new Date());
        
        return this.http
            .post<any>(`${environment.websiteUrl}/chat/discovery`, {}, { 
                withCredentials: true 
            })
            .subscribe({
                next: () => {
                    this.setupSSE();
                },
                error: error => {
                    this.timeout = setTimeout((_) => {
                        this.init();
                    }, 1000);
                }
            });
    }

    close() {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
        }

        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }

        if (this.timeoutReset) {
            clearTimeout(this.timeoutReset);
            this.timeoutReset = null;
        }
    }

    clear() {
        this.close();
        if (this.bifrostInterval) {
            clearInterval(this.bifrostInterval);
            this.bifrostInterval = null;
        }
    }

    public setupSSE() {
        this.debugService.send("!!!!!!!!!!!!! INIT SSE !!!!!!!!!!!!!");
        
        this.close();
        
        this.getServerSentEvent(
            `${environment.mercureUrl}/.well-known/mercure`
        ).subscribe(
            event => {
                let message:Model = JSON.parse(event.data);
                if (message['@type'] != 'UserOnline') {
                    this.debugService.send(event.data);
                    this.eventsSubject.next(JSON.parse(event.data));
                }

                if (message['@type'] == 'Room') {
                    // this.init();
                }
            },
            error => {
                this.init();
            }
        );

        this.startResetTimeout();
        
    }

    private startResetTimeout() {
        // if (this.timeoutReset) {
        //     clearTimeout(this.timeoutReset);
        //     this.timeoutReset = null;
        // }

        // this.timeoutReset = setTimeout((_) => {
        //     this.init();
        // }, 1000 * 60 * 2);
    }

    private getServerSentEvent(url: string, topic: string = '*'): Observable<MessageEvent> {
        return new Observable(observer => {
            const subscribeURL = new URL(url);
            if (this.lastEventID) {
                subscribeURL.searchParams.append(
                    "lastEventID",
                    this.lastEventID
                );
            }
            subscribeURL.searchParams.append("topic", topic);

            const EventSource = EventSourcePolyfill || NativeEventSource;

            this.eventSource = new EventSource(subscribeURL, { withCredentials: true, eventSourceClass: EventSource });

            this.eventSource.onmessage = event => {
                this.lastEventID = event.lastEventId;
                this.lastEventDate = new Date();
                this.zone.run(() => observer.next(event));

                this.startResetTimeout();
            };

            this.eventSource.onopen = event => {
                this.reconnectFrequencySeconds = 0.1;
            };

            this.eventSource.onerror = event => {
                this.debugService.send("ERROR SSE - " + JSON.stringify(event));
                if (event.status == 401) {
                    this.init();
                } else {
                    this.timeout = setTimeout((_) => {
                        this.reconnectFrequencySeconds += 1

                        if (this.reconnectFrequencySeconds > 10) {
                            this.init();
                        } else {
                            this.setupSSE();
                        }
                    }, Math.min(10000, 1000 * this.reconnectFrequencySeconds));
                }
            };
        });
    }
}
